module.exports = __webpack_public_path__ + "img/17_7.0d57560f.png";